import { useEffect } from 'react'

export const useOnWindowResize = (callFunction: () => void): void => {
  useEffect(() => {
    window.addEventListener('resize', callFunction)

    callFunction()

    return () => window.removeEventListener('resize', callFunction)
  }, [callFunction])
}
